// Shared across every proposal: the 15-step timeline from today to closing.
// Edit here once; every client's page picks it up.

export const timeline = [
  "Start our text thread",
  "Choose the listing date and price",
  "Sign listing paperwork (by email)",
  "Schedule vendors",
  "Photo shoot",
  "Marketing campaign prep",
  "List",
  "Launch campaign",
  "Open houses",
  "Offer review date",
  "Negotiation",
  "Sign offer",
  "30 days pending to close",
  "Sign closing paperwork with a notary",
  "Close and receive your funds",
];
